<template>
    <v-card class="px-4">
        <v-card-text class="pa-0 mt-3" style="height: 650px;">
            <v-layout row style="overflow-y: auto; overflow-x: hidden;">
                <v-flex xs6 column>
                    <v-card-title class="headline pt-1 pb-2 px-0"
                        >Payment</v-card-title
                    >
                    <v-select
                        class="mb-4"
                        :items="paymentTypes.map((v) => v.value)"
                        label="Payment Type"
                        v-model="type"
                        ref="paymentType"
                        @change="typeChanged"
                        hide-details
                    >
                    </v-select>
                    <v-text-field
                        class="mb-0"
                        type="number"
                        label="Amount"
                        :disabled="type.includes('Check')"
                        ref="amount"
                        v-model="amount"
                        :rules="amountRules"
                        @input="updateSchedules"
                        prefix="$"
                    ></v-text-field>
                    <v-checkbox
                        class="mb-3 mt-0"
                        hide-details
                        label="Schedule Payments"
                        color="success"
                        v-model="schedulePayments"
                        @input="paymentModeUpdated"
                        v-if="getPaymentTypeSettings().allowSchedule"
                    ></v-checkbox>
                    <v-checkbox
                        class="mb-3 mt-0"
                        hide-details
                        label="Do not charge automatically"
                        color="success"
                        v-model="disableSchedule"
                        v-if="
                            getPaymentTypeSettings().allowSchedule &&
                                schedulePayments &&
                                !type.includes('Check')
                        "
                    ></v-checkbox>

                    <div v-if="type == 'Credit Card'">
                        <v-layout column>
                            <v-select
                                v-if="getPaymentMethods().length"
                                class="mb-2"
                                clearable
                                :items="getPaymentMethods()"
                                label="Cards On File"
                                v-model="selectedCard"
                                item-text="`${data.item.cardInfo}`"
                            >
                                <template slot="selection" slot-scope="data">
                                    {{ data.item.cardInfo }}
                                </template>
                                <template slot="item" slot-scope="data">
                                    <v-list-tile-content>
                                        <v-list-tile-title
                                            v-html="`${data.item.cardInfo}`"
                                        >
                                        </v-list-tile-title>
                                    </v-list-tile-content>
                                </template>
                            </v-select>
                            <div v-if="!selectedCard">
                                <v-text-field
                                    class=""
                                    label="Card Number"
                                    ref="cardNumber"
                                    :mask="creditCardMask"
                                    v-model="cardNumber"
                                    :rules="cardNumberRules"
                                    append-icon="mdi-credit-card"
                                ></v-text-field>
                                <v-layout row class="mb-2">
                                    <v-select
                                        class="mr-1 "
                                        ref="expirationMonth"
                                        :items="getMonthOptions()"
                                        label="Exp. Month"
                                        v-model="expirationMonth"
                                        :rules="expirationMonthRules"
                                    ></v-select>
                                    <v-select
                                        :items="getYearOptions()"
                                        ref="expirationYear"
                                        v-model="expirationYear"
                                        :rules="expirationYearRules"
                                        label="Exp. year"
                                    ></v-select>
                                </v-layout>
                                <v-layout row class="mb-4">
                                    <v-text-field
                                        style="margin-bottom: -27px"
                                        label="Security Code"
                                        ref="securityCode"
                                        v-model="securityCode"
                                        :rules="securityCodeRules"
                                        :mask="securityCodeMask"
                                    ></v-text-field>
                                    <div style="height: 48px">
                                        <img
                                            src="https://utaw.blob.core.windows.net/images/credit-card-cvc-all.svg"
                                            style="width: 77px;"
                                        />
                                        <img
                                            src="https://utaw.blob.core.windows.net/images/credit-card-cvc-amex.svg"
                                            style="width: 77px;"
                                        />
                                    </div>
                                </v-layout>
                                <v-checkbox
                                    class="mb-2"
                                    hide-details
                                    label="Save For Future"
                                    color="success"
                                    v-model="saveForFuture"
                                ></v-checkbox>
                            </div>
                        </v-layout>
                    </div>
                    <div v-if="type == 'ACH'">
                        <v-layout column>
                            <v-select
                                v-if="getPaymentMethods().length"
                                class="mb-2"
                                clearable
                                :items="getPaymentMethods()"
                                label="Cards On File"
                                v-model="selectedCard"
                                item-text="`${data.item.cardInfo}`"
                            >
                                <template slot="selection" slot-scope="data">
                                    {{ data.item.cardInfo }}
                                </template>
                                <template slot="item" slot-scope="data">
                                    <v-list-tile-content>
                                        <v-list-tile-title
                                            v-html="`${data.item.cardInfo}`"
                                        >
                                        </v-list-tile-title>
                                    </v-list-tile-content>
                                </template>
                            </v-select>
                            <div v-if="!selectedCard">
                                <v-text-field
                                    class=""
                                    label="Name On Account"
                                    ref="nameOnAccount"
                                    v-model="nameOnAccount"
                                    :rules="requiredRules"
                                ></v-text-field>
                                <v-text-field
                                    class=""
                                    label="Routing Number"
                                    ref="routingNumber"
                                    v-model="routingNumber"
                                    :rules="requiredRules"
                                ></v-text-field>
                                <v-text-field
                                    class=""
                                    label="Account Number"
                                    ref="accountNumber"
                                    v-model="accountNumber"
                                    :rules="requiredRules"
                                ></v-text-field>
                                <v-checkbox
                                    class="mb-2"
                                    hide-details
                                    label="Save For Future"
                                    color="success"
                                    v-model="saveForFuture"
                                ></v-checkbox>
                            </div>
                        </v-layout>
                    </div>
                    <div>
                        <!-- <v-text-field
                            class="mb-2"
                            label="Check Number"
                            ref="checkNumber"
                            v-model="checkNumber"
                            v-if="type.includes('Check')"
                        ></v-text-field> -->

                        <!-- <v-menu
                            v-model="datePickerMenu"
                            v-if="type.includes('Check')"
                            :close-on-content-click="false"
                            full-width
                            max-width="290"
                        >
                            <template v-slot:activator="{ on }">
                                <v-text-field
                                    :value="formatedDate"
                                    label="Date"
                                    readonly
                                    v-on="on"
                                ></v-text-field>
                            </template>
                            <v-date-picker
                                v-model="date"
                                :min="today"
                                @change="datePickerMenu = false"
                            ></v-date-picker>
                        </v-menu> -->
                    </div>

                    <v-text-field
                        class="mb-2"
                        v-if="showEmail()"
                        v-model="emailAddress"
                        :rules="emailRules"
                        label="Email receipt to"
                        ref="email"
                    ></v-text-field>

                    <v-text-field
                        class="mb-2"
                        label="Note"
                        ref="note"
                        v-model="notes"
                        :rules="noteRules"
                        @input="updateEmailMessage"
                    ></v-text-field>

                    <v-menu
                        v-if="!getPaymentTypeSettings().allowSchedule"
                        v-model="datePickerMenu"
                        :close-on-content-click="false"
                        full-width
                        max-width="290"
                    >
                        <template v-slot:activator="{ on }">
                            <v-text-field
                                :value="date"
                                label="Date"
                                readonly
                                v-on="on"
                            ></v-text-field>
                        </template>
                        <v-date-picker
                            v-model="date"
                            @change="datePickerMenu = false"
                        ></v-date-picker>
                    </v-menu>

                    <div v-if="type == 'HG'">
                        <!-- <v-layout row>
                            <span>HG EMAIL</span>
                            <div
                                style="border-bottom: 2px solid #5cb860;"
                                class="mb-4"
                            ></div>
                        </v-layout> -->
                        <v-layout row class="pa-0 mx-0 mb-3">
                            <div class="font-weight-medium mr-0 subheading">
                                HG EMAIL
                            </div>
                            <v-divider
                                style="border-color: #4caf50; margin-top: 14px !important;"
                                class="pt-2"
                            ></v-divider>
                        </v-layout>
                        <v-text-field
                            class="mb-2 pt-2"
                            v-model="email.emailAddress"
                            :rules="emailRequiredRules"
                            label="Email To"
                            ref="emailAddress"
                        ></v-text-field>
                        <v-text-field
                            class="mb-2 pt-2"
                            v-model="email.userEmail"
                            :rules="emailRequiredRules"
                            label="User Email"
                            ref="userEmail"
                        ></v-text-field>
                        <v-text-field
                            class="mb-2 pt-2"
                            v-model="email.subject"
                            :rules="requiredRules"
                            label="Subject"
                            ref="subject"
                        ></v-text-field>
                        <v-textarea
                            class="mb-2 pt-2"
                            v-model="email.text"
                            label="Message"
                            rows="6"
                            ref="emailText"
                            outline
                        ></v-textarea>
                    </div>
                </v-flex>
                <v-divider vertical></v-divider>
                <v-flex xs6 column>
                    <schedule-payment
                        v-if="showSchedules()"
                        :schedules="scheduledPayments"
                        :checkDetails="checkDetails"
                        :schedulePayments="schedulePayments"
                        :addSchedule="addSchedule"
                        :removeSchedule="removeSchedule"
                        :addCheck="addCheck"
                        :removeCheck="removeCheck"
                        :schedulesDiscrepancy="schedulesDiscrepancy"
                        :paymentType="type"
                        :updateSchedules="updateSchedules"
                        :updateChecks="updateChecks"
                        :amount="amount"
                        ref="schedulePayments"
                    ></schedule-payment>
                </v-flex>
            </v-layout>
        </v-card-text>

        <v-card-actions class="mt-4 mr-0 pb-4">
            <v-spacer></v-spacer>
            <v-btn dark color="default" @click="closePaymentDialog">
                Close
            </v-btn>
            <v-btn
                :loading="processing"
                color="success"
                @click="processPayment"
            >
                Process Payment
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
import moment from "moment";
import cardValidator from "card-validator";
import { loadOptions } from "../../utils/smLookup.js";
import { getDomain, sum, toISOLocal } from "../../utils/helpers.js";
import schedulePayment from "./SchedulePayment.vue";

export default {
    props: {
        paymentMethods: Array,
        closePaymentDialog: Function,
        account: Object,
        ykAccount: Object,
        voucherAccount: Object,
        refresh: Function,
        processURL: String,
        source: String,
        categoryCode: String,
        categoryDescription: String,
        regID: String,
    },
    components: {
        "schedule-payment": schedulePayment,
    },
    data() {
        return {
            type: "Credit Card",
            cardNumber: "",
            expirationMonth: "",
            expirationYear: "",
            securityCode: "",
            notes: "",
            date: toISOLocal(new Date()).substr(0, 10),
            datePickerMenu: false,
            status: "",
            selectedCard: "",
            nameOnCard: "",
            nameOnAccount: "",
            amount: "",
            processing: false,
            checkNumber: "",
            receipt: "",
            today: new Date().toISOString().substr(0, 10),
            emailAddress: "",
            disableSchedule: false,
            schedulePayments: false,
            routingNumber: "",
            accountNumber: "",

            paymentTypes: [],
            scheduledPayments: [],
            checkDetails: [],
            schedulesDiscrepancy: false,
            saveForFuture: true,

            currentRegID: "",

            email: {
                emailAddress: "",
                userEmail: "",
                subject: "",
                text: "",
            },

            amountRules: [
                (value) => !!value || "Amount Is Required",
                (value) => {
                    return (
                        this.type != "Credit Card" ||
                        !value ||
                        value > 0 ||
                        "Amount Can't Be Negative"
                    );
                },
                (value) => {
                    return (
                        !this.type.startsWith("Country Voucher") ||
                        !value ||
                        value <= this.voucherAccount.available ||
                        "Amount Can't Be more than available"
                    );
                },
            ],

            emailRules: [
                (value) => {
                    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                    return !value || pattern.test(value) || "Invalid e-mail.";
                },
            ],

            nameOnCardRules: [
                (v) =>
                    !this.type.includes("Check") || !!v || "Name Is Required",
            ],

            noteRules: [
                (v) =>
                    !this.amount ||
                    !this.getPaymentTypeSettings().noteRequired ||
                    !!v ||
                    "Note Is Required",
            ],

            cardNumberRules: [
                (v) => this.selectedCard || !!v || "Card Number Is Required",
                (v) => (v && this.validateCard()) || "Invalid Card Number",
            ],
            expirationMonthRules: [
                (v) =>
                    this.selectedCard || !!v || "Expiration Month Is Required",
                (v) =>
                    (v && this.validateExpirationMonth()) ||
                    "Invalid Expiration Month",
            ],
            expirationYearRules: [
                (v) =>
                    this.selectedCard || !!v || "Expiration Year Is Required",
                (v) =>
                    (v && this.validateExpirationYear()) ||
                    "Invalid Expiration Year",
            ],
            securityCodeRules: [
                // (v) => this.selectedCard || !!v || "Security Code Is Required",
                (v) =>
                    !v ||
                    (v && this.validateSecurityCode()) ||
                    "Invalid Security Code",
            ],

            requiredRules: [(v) => !!v || "Required"],
            emailRequiredRules: [
                (value) => !!value || "Required",
                (value) => {
                    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                    return !value || pattern.test(value) || "Invalid e-mail.";
                },
            ],
        };
    },
    async created() {
        if (!this.$route.query.voucherPayment) {
            await this.loadPaymentTypes();
        }

        this.scheduledPayments.push({
            date: toISOLocal(
                new Date(
                    moment().add(this.scheduledPayments.length + 1, "months"),
                ),
            ).substr(0, 10),
            amount: 0,
            datePickerMenu: false,
            checkNumber: "",
        });

        this.checkDetails.push({
            date: toISOLocal(new Date(moment())).substr(0, 10),
            amount: 0,
            datePickerMenu: false,
            checkNumber: "CASH",
        });

        this.loadHgPaymentSetup();
        this.loadRegID(this.source);
    },
    computed: {
        formatedDate() {
            return this.date ? moment(this.date).format("L") : "";
        },
        creditCardMask() {
            const numberValidation = cardValidator.number(this.cardNumber);

            return numberValidation.card &&
                numberValidation.card.type == "american-express"
                ? "#### ###### #####"
                : "#### #### #### ####";
        },
        securityCodeMask() {
            const numberValidation = cardValidator.number(this.cardNumber);

            return numberValidation.card && numberValidation.card.code.size == 4
                ? "####"
                : "###";
        },
    },
    watch: {
        amount(newValue, oldValue) {
            this.updateEmailMessage();

            if (!this.scheduledPayments.length) return;

            // const scheduledPaymentsTotal = sum(
            //     this.scheduledPayments.slice(1).map((s) => +s.amount),
            // );

            // this.scheduledPayments[0].amount = Math.max(
            //     0,
            //     newValue - scheduledPaymentsTotal,
            // ).toFixed(2);
        },
        date(newValue, oldValue) {
            if (!this.scheduledPayments.length) return;

            this.scheduledPayments[0].date = this.date;
        },
        ykAccount(newValue, oldValue) {
            this.emailAddress = newValue.emailAddress.trim();
        },
        voucherAccount(newValue, oldValue) {
            this.loadPaymentTypes();
        },
        source(newValue, oldValue) {
            this.loadRegID(newValue);
        },
    },
    methods: {
        async loadRegID(source) {
            if (source == "LAPIDUS") {
                this.currentRegID = await this.$http.get(
                    "api/lapidusDayCamp/getRegID",
                );
            }

            if (source == "YK") {
                this.currentRegID = await this.$http.get("api/yk/getRegID");
            }
        },
        async loadPaymentTypes() {
            const paymentTypes = await this.$http.get(
                "api/payments/getPaymentTypes?categoryCode=" +
                    this.categoryCode,
            );

            const available = this.voucherAccount
                ? this.voucherAccount.available
                : 0;

            this.paymentTypes = paymentTypes.map((paymentType) => {
                if (paymentType.value != "Country Voucher") return paymentType;

                if (available || available === 0) {
                    paymentType.value =
                        paymentType.value + " ($" + available + ")";
                }

                return paymentType;
            });

            if (this.$route.query.voucherPayment) {
                const voucherPaymentType = this.paymentTypes.find((p) =>
                    p.value.startsWith("Country Voucher"),
                );

                this.type = voucherPaymentType
                    ? voucherPaymentType.value
                    : this.type;
            } else {
                this.paymentTypes = this.paymentTypes.filter(
                    (p) => p.value != "Country Voucher",
                );
            }

            this.$forceUpdate();
        },
        getPaymentMethods() {
            if (!this.type) return [];

            return this.type == "Credit Card"
                ? this.paymentMethods.filter((t) => t.type == "CC")
                : this.paymentMethods.filter((t) => t.type == "CK");
        },
        getMonthOptions() {
            const months = [
                { value: "01", text: "1 January" },
                { value: "02", text: "2 February" },
                { value: "03", text: "3 March" },
                { value: "04", text: "4 April" },
                { value: "05", text: "5 May" },
                { value: "06", text: "6 June" },
                { value: "07", text: "7 July" },
                { value: "08", text: "8 August" },
                { value: "09", text: "9 September" },
                { value: "10", text: "10 October" },
                { value: "11", text: "11 November" },
                { value: "12", text: "12 December" },
            ];

            if (this.expirationYear != moment().format("YY")) return months;

            const currentMonth = new Date().getMonth();

            return months.filter((month) => +month.value >= currentMonth + 1);
        },
        getYearOptions() {
            const currentYear = moment().year();
            const currentMonth = moment().month() + 1;
            const yearOptions = [];

            for (let i = 0; i < 10; i++) {
                const year = moment()
                    .add(i, "years")
                    .year();

                if (this.expirationMonth <= currentMonth && i == 0) continue;

                yearOptions.push({
                    text: year,
                    value: year.toString().slice(-2),
                });
            }
            return yearOptions;
        },

        async loadHgPaymentSetup() {
            const emailAddress = await this.$http.get(
                "api/payments/getHgPaymentEmailAddress",
            );

            this.email.emailAddress = emailAddress;
            this.email.userEmail = this.$store.state.authentication.emailAddress
                ? this.$store.state.authentication.emailAddress
                : this.$store.state.authentication.user;
            this.email.subject = "YKC HG Payment";

            this.updateEmailMessage();
        },
        updateEmailMessage() {
            this.email.text =
                "A new HG payment has been submitted.\n\n" +
                "Account ID: " +
                this.account.accountID +
                "\n" +
                "Name: " +
                this.account.name +
                "\n" +
                "Amount: $" +
                this.amount +
                "\n" +
                "Note: " +
                this.notes;
        },
        typeChanged(change) {
            this.updateEmailMessage();
        },
        updateSchedules(change) {
            if (
                (this.type != "Credit Card" && this.type != "ACH") ||
                !this.schedulePayments
            )
                return;

            const startDate = this.$refs.schedulePayments.startDate;
            const scheduleCount = this.$refs.schedulePayments.scheduleCount;
            const scheduleMode = this.$refs.schedulePayments.scheduleMode;

            if (change == "scheduleAmountChange") {
                this.amount = sum(
                    this.scheduledPayments.map((s) => +s.amount),
                ).toFixed(2);
            } else {
                this.scheduledPayments = [];
                const scheduleAmount = +this.amount / scheduleCount;

                for (var i = 0; i < scheduleCount; i++) {
                    const schedule = {
                        date: new Date().toISOString().substr(0, 10),
                        amount: 0,
                        datePickerMenu: false,
                    };

                    schedule.amount = +scheduleAmount.toFixed(2);

                    const scheduleDate =
                        scheduleMode == "month"
                            ? new Date(moment(startDate).add(i, "months"))
                            : new Date(moment(startDate).add(i, "week"));

                    schedule.date = toISOLocal(scheduleDate).substr(0, 10);

                    this.scheduledPayments.push(schedule);
                }

                //this.amount = sum(this.scheduledPayments.map((s) => +s.amount));
            }
        },
        updateChecks(change) {
            this.amount = sum(this.checkDetails.map((s) => +s.amount));
        },
        paymentModeUpdated(value) {
            if (this.type.includes("Check")) {
                this.updateChecks();
            } else {
                this.updateSchedules();
            }
        },
        getPaymentTypeSettings() {
            if (!this.paymentTypes.length || !this.type) return {};

            return this.paymentTypes.find((p) => p.value == this.type);
        },
        getPaymentTypes() {
            return this.paymentTypes;

            // return this.paymentTypes.map((paymentType) => {
            //     if (paymentType != "Country Voucher") return paymentType;

            //     return this.voucherAccount.available
            //         ? paymentType + " ($" + this.voucherAccount.available + ")"
            //         : paymentType;
            // });
        },
        showEmail() {
            return ["Credit Card", "Cash/Check", "Cash", "ACH"].includes(
                this.type,
            );
        },
        showSchedules() {
            const show =
                (this.getPaymentTypeSettings().requireDetails ||
                    (this.getPaymentTypeSettings().allowSchedule &&
                        this.schedulePayments)) &&
                this.scheduledPayments.length;

            return show;
        },
        validateCard() {
            const numberValidation = cardValidator.number(this.cardNumber);

            const isMatbia =
                this.cardNumber.replaceAll(" ", "").startsWith("8") &&
                this.cardNumber.replaceAll(" ", "").length === 16;

            return numberValidation.isValid || isMatbia;
        },
        validateExpirationMonth() {
            return cardValidator.expirationMonth(this.expirationMonth).isValid;
        },
        validateExpirationYear() {
            return cardValidator.expirationYear(this.expirationYear).isValid;
        },
        validateSecurityCode() {
            const numberValidation = cardValidator.number(this.cardNumber);

            if (
                numberValidation &&
                numberValidation.card &&
                numberValidation.card.code
            ) {
                return cardValidator.cvv(
                    this.securityCode,
                    numberValidation.card.code.size,
                ).isValid;
            }

            return cardValidator.cvv(this.securityCode).isValid;
        },

        validateScheduledPayments() {
            const scheduledPaymentsTotal = sum(
                this.scheduledPayments.map((s) => +s.amount),
            );

            const discrepancy = this.amount != scheduledPaymentsTotal;

            this.schedulesDiscrepancy = discrepancy;

            return !discrepancy;
        },
        validateCheckDetails() {
            const scheduledPaymentsTotal = sum(
                this.checkDetails.map((s) => +s.amount),
            );

            const discrepancy = this.amount != scheduledPaymentsTotal;

            this.schedulesDiscrepancy = discrepancy;

            return !discrepancy;
        },
        validate() {
            const validations = [
                this.$refs.amount.validate(true),
                this.$refs.note.validate(true),
            ];

            if (this.type == "Credit Card") {
                validations.push(this.$refs.email.validate(true));

                if (!this.selectedCard) {
                    validations.push(this.$refs.cardNumber.validate(true));
                    validations.push(this.$refs.expirationMonth.validate(true));
                    validations.push(this.$refs.expirationYear.validate(true));
                    validations.push(this.$refs.securityCode.validate(true));
                }

                // if (this.schedulePayments) {
                //     validations.push(this.validateScheduledPayments());
                // }
            }

            if (this.type == "ACH") {
                validations.push(this.$refs.email.validate(true));

                if (!this.selectedCard) {
                    validations.push(this.$refs.routingNumber.validate(true));
                    validations.push(this.$refs.accountNumber.validate(true));
                    validations.push(this.$refs.nameOnAccount.validate(true));
                }

                // if (this.schedulePayments) {
                //     validations.push(this.validateScheduledPayments());
                // }
            }

            // if (this.type.includes("Check")) {
            //     validations.push(this.validateCheckDetails());
            // }

            if (this.type.includes("HG")) {
                validations.push(this.$refs.emailAddress.validate(true));
                validations.push(this.$refs.userEmail.validate(true));
                validations.push(this.$refs.subject.validate(true));
                validations.push(this.$refs.emailText.validate(true));
            }

            return validations.every(Boolean);
        },
        addSchedule() {
            this.scheduledPayments.push({
                date: toISOLocal(
                    new Date(
                        moment().add(
                            this.scheduledPayments.length + 1,
                            "months",
                        ),
                    ),
                ).substr(0, 10),
                amount: 0,
                datePickerMenu: false,
                checkNumber: "",
            });

            this.updateSchedules();
        },
        removeSchedule(index) {
            this.scheduledPayments.splice(index, 1);

            this.updateSchedules();
        },
        addCheck() {
            const lastCheck = this.checkDetails[this.checkDetails.length - 1];
            const lastDate = lastCheck ? moment(lastCheck.date) : moment();

            this.checkDetails.push({
                date: toISOLocal(new Date(lastDate.add(1, "months"))).substr(
                    0,
                    10,
                ),
                amount: 0,
                datePickerMenu: false,
                checkNumber: "CASH",
            });

            this.updateChecks();
        },
        removeCheck(index) {
            this.checkDetails.splice(index, 1);

            this.updateChecks();
        },
        isScheduledPayment(schedule) {
            return !this.isToday(schedule.date);
        },
        isToday(date) {
            return moment(date).isSame(new Date(), "day");
        },
        getPaymentType(type) {
            if (type == "Credit Card") return "CC";
            if (type == "ACH") return "CK";

            return type;
        },
        getCheckDetails() {
            if (this.type != "Cash/Check" || this.schedulePayments) return;

            return this.checkDetails
                .filter((c) => +c.amount > 0 || +c.amount < 0)
                .map((check) => {
                    check.date = moment().format("YYYY-MM-DD HH:mm:ss");

                    return check;
                });
        },
        getScheduledChecks() {
            if (this.type != "Cash/Check" || !this.schedulePayments) return;

            return this.checkDetails.filter((c) => +c.amount > 0);
        },
        getDepartmentID() {
            switch (this.categoryCode) {
                case "LAPD":
                    return 4;
                case "LAPC":
                    return 5;
                case "LPDC":
                    return 46;
                case "YKC":
                    return 45;
            }
        },
        getPaymentData() {
            const payments = this.scheduledPayments.filter((s) => s.amount > 0);

            const currentPaymentAmount =
                this.showSchedules() && this.type != "Cash/Check"
                    ? sum(
                          payments
                              .filter((s) => {
                                  return this.isToday(s.date);
                              })
                              .map((schedule) => +schedule.amount),
                      )
                    : +this.amount;

            return {
                receipt: this.receipt,
                user: this.$store.state.authentication.user,
                regID: this.currentRegID,
                //checkNumber: this.checkNumber,
                voucherAccountID: this.voucherAccount
                    ? this.voucherAccount.accountID
                    : null,
                paymentTypeID: this.getPaymentTypeSettings().id,
                checks: this.getScheduledChecks(),
                checkDetails: this.getCheckDetails(),
                categoryCode: this.categoryCode,
                categoryDescription: this.categoryDescription,
                hgPaymentEmailData: {
                    emailAddress: this.email.emailAddress,
                    userEmail: this.email.userEmail,
                    subject: this.email.subject,
                    text: this.email.text,
                },
                payment: {
                    isTestPayment: window.location.origin.startsWith(
                        "http://localhost",
                    ),
                    paymentMethodID:
                        (this.type == "Credit Card" || this.type == "ACH") &&
                        this.selectedCard
                            ? this.selectedCard.id
                            : null,
                    accountID: this.account.accountID,
                    billingName: this.account.name,
                    nameOnCard: this.nameOnAccount,
                    appSource: this.source,
                    departmentId: this.getDepartmentID(),
                    emailAddressArray: this.emailAddress
                        ? [this.emailAddress]
                        : ["no-reply@utaw.org"],
                    paymentCategories:
                        currentPaymentAmount > 0
                            ? [
                                  {
                                      categoryCode: this.categoryCode,
                                      amount: currentPaymentAmount,
                                  },
                              ]
                            : null,
                    paymentDate:
                        this.type == "Cash/Check" ||
                        !this.getPaymentTypeSettings().allowSchedule
                            ? moment(this.date).format("YYYY-MM-DD HH:mm:ss")
                            : moment().format("YYYY-MM-DD HH:mm:ss"),
                    paymentType: this.getPaymentType(this.type),
                    saveForFuture: this.saveForFuture,
                    x_Amount: currentPaymentAmount || null,
                    x_exp_date: this.expirationMonth + this.expirationYear,
                    x_Card_Num:
                        this.getPaymentType(this.type) == "CK"
                            ? this.routingNumber
                                ? this.routingNumber + "|" + this.accountNumber
                                : ""
                            : this.cardNumber,
                    x_CVV_Code: this.securityCode,
                    notes: this.notes,
                    schedule:
                        this.showSchedules() &&
                        this.type != "Cash/Check" &&
                        payments.filter(this.isScheduledPayment).length
                            ? {
                                  recurrenceCount: payments.filter(
                                      this.isScheduledPayment,
                                  ).length,
                                  recurrenceType: "custom",
                                  scheduledTransectionDetails: payments
                                      .filter(this.isScheduledPayment)
                                      .map((schedule) => ({
                                          scheduleDate: schedule.date,
                                          amount: schedule.amount,
                                          disabled: this.disableSchedule,
                                          paymentCategories: [
                                              {
                                                  categoryCode: this
                                                      .categoryCode,
                                                  amount: +schedule.amount,
                                              },
                                          ],
                                      })),
                              }
                            : null,
                },
            };
        },
        hasLateSchedule() {
            if (
                !this.showSchedules() ||
                this.type != "Credit Card" ||
                !this.scheduledPayments.filter(this.isScheduledPayment).length
            )
                return false;

            const endOfYear = new Date(
                this.ykAccount.regID.replaceAll(/\D/g, ""),
                11,
                31,
            );

            return this.scheduledPayments.some(
                (s) =>
                    this.isScheduledPayment(s) && new Date(s.date) > endOfYear,
            );
        },
        async processPayment() {
            if (!this.validate()) return;

            // if (this.hasLateSchedule()) {
            //     return this.$notify({
            //         text: "Can't schedule payments for next year",
            //         group: "notification",
            //         type: "error",
            //     });
            // }

            this.processing = true;

            const paymentData = this.getPaymentData();

            try {
                await this.$http.post(
                    "api/payments/processPayment",
                    paymentData,
                );
            } catch (e) {
                this.processing = false;

                return;
            }

            // if (this.type == "HG") {
            //     this.sendHgPaymentEmail();
            // }

            this.processing = false;

            this.$notify({
                text: "Payment Saved",
                group: "notification",
                type: "success",
            });

            this.clear();

            this.closePaymentDialog();

            this.refresh();
        },
        async sendHgPaymentEmail() {
            await this.$http.post("api/payments/emailHGPayment", {
                emailAddress: this.email.emailAddress,
                userEmail: this.email.userEmail,
                subject: this.email.subject,
                text: this.email.text,
            });
        },
        clear() {
            this.cardNumber = "";
            this.expirationMonth = "";
            this.expirationYear = "";
            this.securityCode = "";
            this.notes = "";
            this.status = "";
            this.selectedCard = "";
            this.nameOnCard = "";
            this.amount = "";
            this.checkNumber = "";
            this.receipt = "";
            this.date = toISOLocal(new Date()).substr(0, 10);

            this.scheduledPayments = [
                {
                    date: toISOLocal(
                        new Date(
                            moment().add(
                                this.scheduledPayments.length + 1,
                                "months",
                            ),
                        ),
                    ).substr(0, 10),
                    amount: 0,
                    datePickerMenu: false,
                    checkNumber: "",
                },
            ];
            this.checkDetails = [
                {
                    date: toISOLocal(new Date(moment())).substr(0, 10),
                    amount: 0,
                    datePickerMenu: false,
                    checkNumber: "CASH",
                },
            ];

            this.schedulesDiscrepancy = false;

            if (this.type == "Credit Card" && this.$refs.cardNumber) {
                this.$refs.cardNumber.resetValidation();
                this.$refs.expirationMonth.resetValidation();
                this.$refs.expirationYear.resetValidation();
                this.$refs.securityCode.resetValidation();
            }

            this.$refs.amount.resetValidation();

            if (
                this.$refs.schedulePayments &&
                this.$refs.schedulePayments.clearScheduleCount
            ) {
                this.$refs.schedulePayments.clearScheduleCount();
            }

            this.type = "Credit Card";
        },
        getData() {
            return this;
        },
    },
};
</script>
<style>
.scroll-container {
    height: 100%;
    overflow-y: scroll;
    backface-visibility: hidden;
}
</style>
